import BaseTemplate from '../src/layouts/BaseTemplate'
import CisdView from '../src/view/_public/CisdView';

export default function Cisd() {
  return (
    <BaseTemplate title="Clinical and Intervention Services Department" body={<CisdView />} />
  )
}
